var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "47px",
    viewBox: "0 0 46 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_CC-credit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 17.3138847,
    cy: 17.4690246,
    rx: 17.3138847,
    ry: 17.4690246
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.8%",
    y: "-20.0%",
    width: "163.5%",
    height: "163.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.192156863   0 0 0 0 0.239215686  0 0 0 0.08 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.192156863   0 0 0 0 0.239215686  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recent_Transactions",
    transform: "translate(-4.000000, -143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_CC-credit",
    transform: "translate(10.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.245787,23.064062 L10.388908,23.064062 C9.62361366,23.064062 9.00322006,22.4381094 9.00322006,21.6659578 L9.00322006,12.57828 C9.00322006,11.8061284 9.62361366,11.1801757 10.388908,11.1801757 L24.245787,11.1801757 C25.0110813,11.1801757 25.6314749,11.8061284 25.6314749,12.57828 L25.6314749,21.6659578 C25.6314749,22.4381094 25.0110813,23.064062 24.245787,23.064062 Z M24.245787,14.3259104 C24.245787,14.1328724 24.0906886,13.9763843 23.8993651,13.9763843 L10.7353299,13.9763843 C10.5440064,13.9763843 10.388908,14.1328724 10.388908,14.3259104 L10.388908,15.7240146 C10.388908,15.9170525 10.5440064,16.0735407 10.7353299,16.0735407 L23.8993651,16.0735407 C24.0906886,16.0735407 24.245787,15.9170525 24.245787,15.7240146 L24.245787,14.3259104 Z",
    id: "Credit-Card-Back",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#7E7E84",
    cx: 23.5468832,
    cy: 21.6615905,
    rx: 4.15533233,
    ry: 4.19256591
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3528049,23.6855028 C24.2544958,23.7819151 24.0950096,23.782009 23.9965824,23.6857123 C23.8981552,23.5894157 23.8980594,23.4331943 23.9963684,23.3367819 L25.4587847,21.9060403 L21.0283468,21.9060403 C20.8893449,21.9060403 20.7766617,21.7956637 20.7766617,21.6595073 C20.7766617,21.5233509 20.8893449,21.4129744 21.0283468,21.4129744 L25.4545186,21.4129744 L23.9963684,19.9863991 C23.8980594,19.8899868 23.8981552,19.7337653 23.9965824,19.6374687 C24.0950096,19.5411721 24.2544958,19.5412659 24.3528049,19.6376782 L26.243262,21.4872301 C26.2905374,21.5334416 26.3171048,21.5961757 26.3171048,21.6615967 C26.3171048,21.7270177 26.2905374,21.7897517 26.243262,21.8359633 L24.3528049,23.6855028 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(23.546883, 21.661591) scale(-1, 1) translate(-23.546883, -21.661591) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.f100f986b2ae9ce8acad84b73b6ab05f.svg";
export { ForwardRef as ReactComponent };